export default __webpack_public_path__ + "static/media/arrow-back.9120fd80.svg";